<div #container>
    <span #mathField></span>
</div>
